<ul>
  <li *ngFor="let item of layoutTopbarMenuList" class="itemMenu" (click)="clickItemMenu(item.action)">
    <i class="mu-icon {{ item.icon }}" aria-hidden="true"></i>
    <span class="topbar-item-name">{{ item.label | translate }}</span>
  </li>
</ul>
